var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvertising(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 29.578h-4.688a1.672 1.672 0 0 1-1.671-1.672v-12.5a1.672 1.672 0 0 1 1.672-1.672H33a5 5 0 0 1 5 5v5.813a5.001 5.001 0 0 1-5 5.031Zm-3-3.328h3a1.672 1.672 0 0 0 1.672-1.672V18.75A1.672 1.672 0 0 0 33 17.078h-3v9.172ZM18.188 13.766a5 5 0 0 0-5 4.984v9.14a1.673 1.673 0 0 0 2.34 1.69 1.67 1.67 0 0 0 .988-1.69V26.72H20v1.172a1.673 1.673 0 0 0 2.341 1.69 1.67 1.67 0 0 0 .987-1.69V18.75a5.047 5.047 0 0 0-5.14-4.984Zm-1.672 9.671V18.75a1.704 1.704 0 0 1 1.812-1.672A1.672 1.672 0 0 1 20 18.75v4.688h-3.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.672 3.328H8.328A8.344 8.344 0 0 0 0 11.656v20.016A8.344 8.344 0 0 0 8.328 40h15v3.328H20a1.672 1.672 0 0 0 0 3.328h10a1.671 1.671 0 0 0 0-3.328h-3.328v-5A1.672 1.672 0 0 0 25 36.672H8.328a5 5 0 0 1-5-5V11.656a5 5 0 0 1 5-5h33.344a5 5 0 0 1 5 5v20.016a5 5 0 0 1-5 5H30A1.671 1.671 0 0 0 30 40h11.672A8.344 8.344 0 0 0 50 31.672V11.656a8.344 8.344 0 0 0-8.328-8.328Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v50H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertising);
export default __webpack_public_path__ + "static/media/advertising.b5aeee5f37ecd0e08ac8531c0d675af4.svg";
export { ForwardRef as ReactComponent };